var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGoogleCalendar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-42.66667,-42.66667) scale(1.33333,1.33333)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333) skewX(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 22,
    height: 22,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.68,20.92l1.008,1.44l1.584,-1.152v8.352h1.728v-10.944h-1.44z",
    fill: "#1e88e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.943,23.745c0.625,-0.574 1.013,-1.37 1.013,-2.249c0,-1.747 -1.533,-3.168 -3.417,-3.168c-1.602,0 -2.972,1.009 -3.33,2.453l1.657,0.421c0.165,-0.664 0.868,-1.146 1.673,-1.146c0.942,0 1.709,0.646 1.709,1.44c0,0.794 -0.767,1.44 -1.709,1.44h-0.997v1.728h0.997c1.081,0 1.993,0.751 1.993,1.64c0,0.904 -0.866,1.64 -1.931,1.64c-0.962,0 -1.784,-0.61 -1.914,-1.418l-1.687,0.276c0.262,1.636 1.81,2.87 3.6,2.87c2.007,0 3.64,-1.511 3.64,-3.368c0,-1.023 -0.504,-1.941 -1.297,-2.559z",
    fill: "#1e88e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,42h-20l-1,-4l1,-4h20l1,4z",
    fill: "#fbc02d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,35l4,-1v-20l-4,-1l-4,1v20z",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,14l1,-4l-1,-4h-25c-1.657,0 -3,1.343 -3,3v25l4,1l4,-1v-20z",
    fill: "#1e88e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,34v8l8,-8z",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,6h-5v8h8v-5c0,-1.657 -1.343,-3 -3,-3z",
    fill: "#1565c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,42h5v-8h-8v5c0,1.657 1.343,3 3,3z",
    fill: "#1565c0"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogleCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/googleCalendar.ea6dd264.svg";
export { ForwardRef as ReactComponent };